<template>

    <SubHeader title="Fiche Affectation" :breads="[{ name: 'Fiche Affection' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(affectationShowItems)">

                <div class="row">
                    <div class="col-md-12">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" name="label" id="label" v-model="affectationShowItems.label" class="form-control" placeholder="Motif"
                                        value="">
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Message de notification (version Mail)</label>
                                    <textarea class="form-control" id="label" v-model="affectationShowItems.message" name="label" rows="4" cols="50" value=""></textarea>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Message de notification (version SMS)</label>
                                    <textarea class="form-control" id="label"  v-model="affectationShowItems.sms" name="label" rows="4" cols="50" value=""></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Modifier</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import {mapFields} from "vuex-map-fields"

export default {
    name: "AdminConfigShowAffectation",
    components: {
        SubHeader
    },
    computed: {
        ...mapFields("affectation/show", {
            affectationShowItems: "item",
            affectationShowIsLoading: "isLoading",
            affectationShowIsSuccess: "isSuccess",
        }),
        ...mapFields("affectation/update", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            isUpdated: "isUpdated",
            item: "item",
        })
    },
    methods: {
        ...mapActions({
            reset: "affectation/show/resetData",
            resetUpdate: "affectation/update/resetData",
            handleSubmit: "affectation/update/update",
            getAffectation: "affectation/show/getOne",
        })
    },
    watch: {
        isUpdated(val){
            if(val){
                this.$router.push({name:'AdminConfigAffectation'})
            }
        }
    },
    mounted() {
        this.getAffectation(this.$route.params.id ?? 0)
    },
    unmounted() {
        this.reset()
        this.resetUpdate()
    }
    
}
</script>
